import React, { useEffect, useState } from 'react'
import { Row, Col, Button, Form } from 'react-bootstrap'
import Card from '../../../components/Card'
import { API_MANAGE_GROUP_CREATE } from '../../../service/url';
import { postApiCall } from '../../../service/postApiCall';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const CreateGroup = () => {

    const [groupName, setGroupName] = useState("")
    const [buttonDisable, setButtonDisable] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({})
    const navigate = useNavigate();


    async function handleGroupCreate(e) {
        e.preventDefault();
        setIsLoading(true);
        setButtonDisable(true);

        if (!groupName.trim()) {
            setErrors({
                NameError: "Group name required"
            })
            setIsLoading(false);
            setButtonDisable(false);
            return;
        }

        const params = {
            group_name: groupName
        }
        try {
            const response = await postApiCall(API_MANAGE_GROUP_CREATE, params);
            if (response) {
                toast.success("Group created successfully");
                setTimeout(() => {
                    navigate("/group-list");
                }, 2000);
            }



        } catch (error) {
            toast.error(error);
        }
    }


    return (
        <div>
            <Row>
                <Col xl="12" lg="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Create Group</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="new-trunk-info"></div>

                            <Form>
                                {/* Group Name Input */}
                                <Form.Group className="mb-3 col-md-6 form-group">
                                    <Form.Label htmlFor="groupName">Group Name:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                    <Form.Control
                                        onChange={(e) => setGroupName(e.target.value)}
                                        type="text"
                                        id="groupName"
                                        value={groupName}
                                        placeholder="Enter group name"
                                        isInvalid={!!errors.NameError}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.NameError}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                {/* Submit Button */}
                                <Button onClick={handleGroupCreate} variant="primary" type="submit">
                                    Create
                                </Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default CreateGroup
